module.exports = __webpack_public_path__ + "img/form_book.bc3f1f4b.png";